import { ThemeModeEnum } from "_constants";
import { styled } from "styled-components";

export const StyledAppLogoShortWrapper = styled.span`
  height: ${({ height }) => height}px;
  svg {
    path:is([fill="#0F172A"]) {
      fill: ${({ theme_mode }) =>
        theme_mode === ThemeModeEnum.DARK ? "#FFF" : "#0F172A"};
    }
  }
`;
